import styled from '@emotion/styled'
import { typography } from '@resiliatech/birdsong'

export const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;
`

export const ListItem = styled.li`
  ${typography.baseline.regularSans};

  list-style-type: none;
  padding: 0;
`
